import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Grid } from "@client/shared/components";
import { globalStyles, noop } from "@client/shared/constants";
import style from "./style";

const EmailUpdatesView = ({
  bbc = [],
  individualContactList = [],
  columnConfig = [],
  handleChange = noop,
}) => {
  return (
    <>
      <Box
        sx={{
          ...globalStyles.width["75"],
        }}
      >
        <Typography variant="body2">
          You will receive email updates on the status of your broadcast once
          the release is completed. Leave blank if you have no BCC.
        </Typography>
      </Box>

      <Box
        sx={{
          mt: 4,
        }}
      >
        <Typography
          variant="h6"
          color="secondary"
          sx={{
            ...globalStyles.text.weight.bold,
          }}
        >
          BCC
        </Typography>
        <Box
          sx={{
            mt: 1,
            ...globalStyles.display.flex,
          }}
        >
          <Autocomplete
            fullWidth
            multiple
            size="small"
            value={bbc}
            options={individualContactList}
            getOptionLabel={(option) =>
              option?.contact?.email ? `${option.name || "-"} - <${option?.contact?.email}>` : "-"
            }
            onChange={(evt, value) => {
              handleChange({ name: "bbc", value }, "autocomplete");
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Add Individual Contacts..." />
            )}
          />
        </Box>
      </Box>
      {!!bbc.length && (
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            ...style.gridPaper,
          }}
        >
          <Grid columns={columnConfig} rows={bbc} hasSelection={false} />
        </Paper>
      )}
    </>
  );
};

export default EmailUpdatesView;
